import SimpleBar from 'simplebar'

window.scrollInit = function() {
  if (window.innerWidth > 1024) {
    $('.js-scroll').each(function() {
      new SimpleBar(this, { autoHide: false });
    })
  }
}

scrollInit();